import React, { useState } from "react";
import { Button } from "reactstrap";
import '../../styles/RequestCard.css';
import { getRequestTableLabel } from '../../utils/requestAdapter';
import { formatRelativeTime } from '../../utils/venueUiFormatters';

const requestTypeTitles = {
  pay_bill: "Hesap Kapatma İsteği",
  need_assistance: "Garson Çağırma İsteği",
  order_ready: "Sipariş Hazır",
  request: "Gelen İstek",
};

const RequestCard = ({ request, onUpdate, dimmed, canUpdate }) => {
  const [isUpdating, setIsUpdating] = useState(false);
  const requestTitle = requestTypeTitles[request.type] || "Talep";
  const tableLabel = getRequestTableLabel(request);
  const isPending = request.status === 'pending';

  const handleUpdateStatus = async () => {
    if (!canUpdate || isUpdating) {
      return;
    }

    const newStatus = isPending ? 'completed' : 'pending';

    setIsUpdating(true);
    try {
      await onUpdate(request.id, newStatus);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <article className={`request-card ${dimmed ? 'dimmed' : ''} ${isPending ? 'request-card--pending' : 'request-card--completed'}`}>
      <div className="request-card__content">
        <div className="request-card__top">
          <div>
            <p className="request-card__eyebrow">{formatRelativeTime(request.created_at)}</p>
            <h3 className="request-card__title">{requestTitle}</h3>
          </div>
          <div className="request-card__chips">
            <span className="venue-chip venue-chip--neutral">{tableLabel}</span>
            <span className={`venue-chip ${isPending ? 'venue-chip--pending' : 'venue-chip--completed'}`}>
              {isPending ? 'Bekliyor' : 'Tamamlandı'}
            </span>
          </div>
        </div>
        <p className="request-card__details">
          {request.details || 'Ek detay paylaşılmadı.'}
        </p>
      </div>

      {canUpdate ? (
        <div className="request-button-container">
          <Button
            className="request-button"
            color={isPending ? 'success' : 'warning'}
            onClick={handleUpdateStatus}
            disabled={isUpdating}
          >
            {isUpdating
              ? 'Güncelleniyor...'
              : isPending
                ? 'Tamamlandı'
                : 'Yeniden Aç'}
          </Button>
        </div>
      ) : null}
    </article>
  );
};

export default RequestCard;
